export interface ITaskTypePage {
    title: string;
    headerClass: string;
    formHeight: number;
    showAttachments: boolean;
    attachmentsHeight: number;
    enableDialogButtons: boolean;
    fields: string[];

    getHash(): string;
}

export class TaskTypePage implements ITaskTypePage {
    title: string;
    headerClass: string;
    formHeight: number;
    showAttachments: boolean;
    attachmentsHeight: number;
    enableDialogButtons: boolean;
    fields: string[];

    constructor();
    constructor(obj: ITaskTypePage);
    constructor(obj?: any) {
        this.title = obj && obj.title || "";
        this.headerClass = obj && obj.headerClass || "";
        this.formHeight = obj && obj.formHeight || 0;
        this.showAttachments = obj && obj.showAttachments || false;
        this.attachmentsHeight = obj && obj.attachmentsHeight || 0;
        this.enableDialogButtons = obj && obj.enableDialogButtons || false;
        this.fields = obj && obj.fields || [];
    }

    getHash(): string {
        return this.title + "#" + this.headerClass + "#" + this.fields.join(";");
    }
}
